/**
 * Index script file
 *
 * @package    App
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import {
    connect,
    Provider,
} from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import {
    IntlProvider,
} from 'react-intl';
import dayjs from 'dayjs';

import store, { history } from 'Reducers/configureStore.js';
import Layout from 'Layouts/Layout';
import { flatten } from 'Utils';

import registerServiceWorker from './registerServiceWorker';

let messages = {};
const IntlPolyfillRequired = !global.Intl;
const ConnectedIntlProvider = connect((store) => {
    const { locale } = store.translations;

    i18n(locale);

    return {
        key: locale,
        locale,
        messages: flatten(messages),
    };
})(IntlProvider);

const render = (Component) => {
    ReactDOM.render(
        <Provider store={ store }>
            <ConnectedIntlProvider>
                <ConnectedRouter history={ history }>
                    <Component history={ history }/>
                </ConnectedRouter>
            </ConnectedIntlProvider>
        </Provider>,
        document.getElementById('root'),
    );
    registerServiceWorker();
};

if (process.env.NODE_ENV !== 'production') {
    const whyDidYouRender = require('@welldone-software/why-did-you-render');

    whyDidYouRender(React);
}

const setLocaleData = (locale) => {
    dayjs.locale(locale);
    render(Layout);
};

const loadLocaleData = (locale) => {
    switch (locale) {
        case 'en':
        default:
            require.ensure([
                'Locales/en.js',
                'dayjs/locale/en',
            ], (require) => {
                messages = require('Locales/en.js').default;
                require('dayjs/locale/en');
                if (IntlPolyfillRequired) {
                    require('intl/locale-data/jsonp/en.js');
                }
                setLocaleData(locale);
            }, 'intl-en');
    }
};

const loadIntlData = (locale) => {
    require.ensure([
        'intl',
    ], (require) => {
        const intl = require('intl');

        global.Intl = intl;
        window.Intl = intl;

        loadLocaleData(locale);
    }, 'intl');
};

const i18n = (locale) => {
    if (IntlPolyfillRequired) {
        loadIntlData(locale);
    } else {
        loadLocaleData(locale);
    }
};

i18n(localStorage.getItem('locale') || document.documentElement.lang);

if (module.hot) {
    module.hot.accept('Layouts/Layout', () => {
        render(Layout);
    });
}
